import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'pxw-icon[icon="geolocation"]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../icon/icon.component.scss'],
  providers: [{ provide: IconComponent, useExisting: IconGeolocationComponent }],
  template: `
    <svg viewBox="0 0 45 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42 23H37.778M37.778 23C37.778 26.9196 36.2219 30.6777 33.4503 33.4493C30.6787 36.2209 26.9196 37.778 23 37.778M37.778 23C37.778 19.0804 36.2219 15.3203 33.4503 12.5487C30.6787 9.77707 26.9196 8.222 23 8.222M23 4V8.222M23 8.222C19.0806 8.222 15.3218 9.77696 12.5504 12.5484C9.77896 15.3198 8.222 19.0786 8.222 22.998C8.222 26.9174 9.77896 30.6762 12.5504 33.4476C15.3218 36.219 19.0806 37.778 23 37.778M4 23H8.222M23 42V37.778"
        stroke="#FF7C7C"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M23 30C24.8565 30 26.637 29.2625 27.9497 27.9497C29.2625 26.637 30 24.8565 30 23C30 21.1435 29.2625 19.363 27.9497 18.0503C26.637 16.7375 24.8565 16 23 16C21.1435 16 19.363 16.7375 18.0503 18.0503C16.7375 19.363 16 21.1435 16 23C16 24.8565 16.7375 26.637 18.0503 27.9497C19.363 29.2625 21.1435 30 23 30Z"
      />
    </svg>
  `,
})
export class IconGeolocationComponent extends IconComponent {}
